import { Form, Select } from 'antd'
import { FC } from 'react'
import { useGetUsersQuery } from '../../../../../../store/api/users-api'
import { filterOptionByLabel } from '../../../../../../helpers/filter-option-by-label'

interface InitiatorsProps {}

const Initiators: FC<InitiatorsProps> = () => {
    const { data } = useGetUsersQuery()

    return (
        <Form.Item name={'initiators'} noStyle>
            <Select
                style={{ width: '100%' }}
                options={data?.map(item => ({ value: item.documentId, label: item.username }))}
                placeholder={'ФИО'}
                mode={'multiple'}
                filterOption={filterOptionByLabel}
                showSearch
            />
        </Form.Item>
    )
}

export default Initiators
